import React, { useState, useEffect } from "react";
import {
  FaSearch,
  FaFolderOpen,
  FaClipboardCheck,
  FaUpload,
  FaHome,
  FaChartBar,
  FaCloud,
  FaPhone,
  FaUser,
  FaChartLine,
  FaFileAlt,
  FaCheckCircle,
  FaComments,
  FaArrowUp,
  FaArrowDown,
  FaArrowRight,
  FaSignOutAlt,
  FaChessKing,
  FaBook,
  FaDatabase
} from "react-icons/fa";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
  useHistory, 
  Redirect
} from "react-router-dom";
import Home from "./routes/Home";
import Search from "./routes/Search";
import Dashboard from "./routes/Dashboard/index";
import Projects from "./routes/Projects";
import CampaignDashboard from "./routes/CampaignDashboard";
import QaEditor from "./routes/QaEditor";
import ScorecardEditor from "./routes/ScorecardEditor";
import ScorecardList from "./routes/ScorecardList";
import TemplateList from "./routes/TemplateList";
import TemplateEditor from "./routes/TemplateEditor";
import TemplateUpload from "./routes/TemplateUpload";
import CampaignList from "./routes/CampaignList";
import CampaignEditor from "./routes/CampaignEditor";
import CampaignDetail from "./routes/CampaignDetail";
import QuickSightEmbed from "./routes/QuickSightEmbed";
import UploadRecs from "./routes/UploadRecordings";
import FileCopy from "./routes/FileCopy";
import Assigned from "./routes/Assigned";
import CallAgents from "./routes/CallAgent";
import UserManagement from "./routes/UserManagement";
import Jobs from "./routes/Jobs";
import JobDetail from "./routes/JobDetail";
import AdminRoute from "./components/AdminRoute";
import useIsAdmin from "./hooks/useIsAdmin";
import useIsQAAgent from "./hooks/useIsQAAgent";
import useIsCallAgent from "./hooks/useIsCallAgent";
import useIsSuperAdmin from "./hooks/useIsSuperAdmin";
import AnimatedSearch from "./components/AnimatedSearch";
import AuditView from "./routes/Audit";
import ScheduledJobs from "./routes/ScheduledJobs";
// import KnowledgeBase from "./routes/KnowledgeBase";
import { payloadFromToken, logOut } from "./api/auth";
import { useLocalStorage } from "./common/localStorage";


const routes = [
  {
    path: "/search",
    name: "Search",
    Component: Search,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Search", href: "search" }
    ], 
    adm : true,
    sAdm: true
  },
  {
    path: "/dashboard/parsedFiles/search",
    name: "Search",
    Component: Search,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Search", href: "search" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/uploadRecs",
    name: "Upload Recordings",
    Component: UploadRecs,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Upload Recordings", href: "/uploadRecs" }
    ],
    adm : true,
    sAdm: true,
    qa: true
  },
  {
    path: "/jobs/:jobId",
    name: "Job Detail",
    Component: JobDetail,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Jobs", href: "/jobs" },
      { text: "Job Detail", href: "/jobs/:jobId" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/jobs",
    name: "Jobs",
    Component: Jobs,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Jobs", href: "/jobs" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/fileCopy",
    name: "Copy Files",
    Component: FileCopy,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Upload Recordings", href: "/fileCopy" }
    ],
    adm : true,
    sAdm: true
  },
  
  {
    path: "/dashboard/:key*",
    name: "Call Details",
    hide: true,
    Component: Dashboard,
    breadcrumbs: [
      { text: "Home", href: "../../" },
      { text: "Call List", href: "../../" },
      { text: "Call Details", href: "#" },
    ],
    adm : true,
    sAdm: true,
    qa: true,
    callAgent: true
  },
  {
    path: "/projects",
    name: "Create a Campaign",
    Component: Projects,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Campaigns", href: "/projects" },
    ],
    adm : true,
    sAdm: true
  },
  
  {
    path: "/scorecards",
    name: "Manage Scorecards",
    Component: ScorecardEditor,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Manage Scorecards", href: "/scorecards" },
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/scorecards/view",
    name: "Scorecards",
    Component: ScorecardList,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Scorecards", href: "/scorecards/view" },
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/templates",
    name: "Scorecards",
    exact: true,
    Component: TemplateList,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Scorecards", href: "/templates" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/templates/upload",
    name: "Upload Scorecard",
    hide: true,
    Component: TemplateUpload,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Scorecards", href: "/templates" },
      { text: "Upload", href: "#" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/templates/new",
    name: "New Scorecard",
    hide: true,
    Component: TemplateEditor,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Scorecards", href: "/templates" },
      { text: "New", href: "#" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/templates/:name",
    name: "Edit Scorecard",
    hide: true,
    Component: TemplateEditor,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Scorecards", href: "/templates" },
      { text: "Edit", href: "#" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/campaigns",
    name: "Campaigns",
    exact: true,
    Component: CampaignList,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Campaigns", href: "/campaigns" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/campaigns/new",
    name: "New Campaign",
    hide: true,
    Component: CampaignEditor,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Campaigns", href: "/campaigns" },
      { text: "New", href: "#" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/campaigns/:name",
    name: "Edit Campaign",
    exact: true,
    hide: true,
    Component: CampaignEditor,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Campaigns", href: "/campaigns" },
      { text: "Edit", href: "#" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/campaigns/view/:name",
    name: "Campaign Detail",
    exact: true,
    hide: true,
    Component: CampaignDetail,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Campaigns", href: "/campaigns" },
      { text: "Detail", href: "#" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/qa",
    name: "QA",
    Component: QaEditor,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "QA", href: "/qa" },
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/quicksight",
    name: "Dashboard",
    Component: QuickSightEmbed,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Dashboard", href: "/quicksight" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/assigned",
    name: "Assigned to Me",
    Component: Assigned,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Assigned", href: "/assigned" }
    ],
    qa: true
  },
  {
    path: "/CallAgent",
    name: "My Calls",
    Component: CallAgents,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "My Calls", href: "/CallAgent" }
    ],
    callAgent: true
  },
  {
    path: "/override-logs",
    name: "Audit",
    Component: AuditView,
    admin: true,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Audit", href: "/override-logs" }
    ],
    adm : true,
    sAdm: true
  },
{
    path: "/scheduled-jobs",
    name: "Scheduled Jobs",
    Component: ScheduledJobs,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Scheduled Jobs", href: "/scheduled-jobs" }
    ],
    adm: true,
    sAdm: true
  },
  {
    path: "/users",
    name: "User Management",
    Component: UserManagement,
    admin: true,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "User Management", href: "/users" }
    ],
    sAdm: true
  },
  // {
  //   path: "/assigned",
  //   name: "Assigned to me",
  //   Component: Assigned,
  //   requiredRoles: ["QAAgent"],
  //   Breadcrumb: () => {
  //     return <BreadcrumbGroup
  //       items={[
  //         { text: "Home", href: "../" },
  //         { text: "Assigned to me", href: "/assigned" }
  //       ]}
  //       ariaLabel="Breadcrumbs"
  //     />
  //   }
  // },
  {
    path: "/",
    name: "Campaign Home",
    Component: CampaignDashboard,
    breadcrumbs: [
      { text: "Campaign Home", href: "/" }
    ],
    adm : true,
    sAdm: true
  }
  // {
  //   path: "/",
  //   name: "Call List",
  //   exact: true,
  //   Component: Home,
  //   breadcrumbs: [
  //     // { text: "Home", href: "#" },
  //     { text: "Call List", href: "#" },
  //   ],
  //   adm : true,
  //   sAdm: true
  // }
];

function TopNavigation({ userName, email, toggleSidebar }) {
  const history = useHistory();
  const isAdmin = useIsAdmin();
  const isSAdmin = useIsSuperAdmin()
  const [showAdmin, setShowAdmin] = useState(false);

  const handleLogout = () => {
    logOut();
    window.location.reload();
  };

  return (
    <div className="bg-gray-900 text-white shadow-sm border-b border-gray-700 sticky top-0 z-50">
      <div className="flex items-center justify-between px-6 py-3">
        <div className="flex items-center space-x-3 cursor-pointer" onClick={() => history.push("/")}>
          <button
            className="mr-2 focus-ring"
            aria-label="Toggle sidebar"
            onClick={(e) => {
              e.stopPropagation();
              toggleSidebar();
            }}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <img
            src={`${process.env.PUBLIC_URL}/images/rewardsco-logo.png`}
            alt="Logo"
            className="h-10 w-auto object-contain hidden md:block"
          />
          <span className="hidden sm:block text-xl font-semibold text-white">Post-Call Analytics</span>
        </div>
        
        <div className="flex items-center space-x-4 w-full max-w-xl">
          <AnimatedSearch />
          
          <div className="relative group">
            <button className="flex items-center space-x-2 px-3 py-2 rounded-lg hover:bg-gray-800 transition-colors focus-ring text-white">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <div className="hidden sm:block text-left">
                <div className="text-sm font-medium">{userName}</div>
                <div className="text-xs text-gray-300">{email}</div>
              </div>
              <svg className="w-4 h-4 ml-1 hidden sm:block" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-10">
              <div className="py-1">
                <button className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                  Profile Settings
                </button>
                {isSAdmin && (
                  <>
                    <button
                      onClick={() => setShowAdmin(v => !v)}
                      className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex justify-between items-center"
                    >
                      Super Admin Settings
                      <svg
                        className={`w-4 h-4 transition-transform ${showAdmin ? 'transform rotate-90' : ''}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </button>
                    {showAdmin && (
                      <div className="pl-4 pb-1">
                        <button
                          onClick={() => history.push('/users')}
                          className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                          User Management
                        </button>
                      </div>
                    )}
                  </>
                )}
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 text-sm text-red-700 hover:bg-red-50"
                >
                  Sign Out
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SideNavigation({ sidebarOpen, closeSidebar }) {
  const location = useLocation();
  const history = useHistory();
  const [activeHref, setActiveHref] = useState(location.pathname);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [sidebarWidth, setSidebarWidth] = useLocalStorage('sidebarWidth', 256);
  const [isResizing, setIsResizing] = useState(false);
  const isAdmin = useIsAdmin();
  const isQAAgent = useIsQAAgent();
  const isSAdmin = useIsSuperAdmin()
  const isCallAgent = useIsCallAgent();

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizing) return;
      const newWidth = Math.min(Math.max(e.clientX, 200), 600);
      setSidebarWidth(newWidth);
    };
    const stopResize = () => setIsResizing(false);

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', stopResize);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', stopResize);
    };
  }, [isResizing, setSidebarWidth]);

  useEffect(() => {
    setActiveHref(location.pathname);
  }, [location.pathname]);

  const isActive = (path) => {
    if (path === "/" && location.pathname === "/") return true;
    if (path !== "/" && location.pathname.startsWith(path)) return true;
    return false;
  };

  const getItemInfo = (href) => {
    switch (href) {
      case '/search':
        return <span className="text-xs text-gray-500">Advanced search</span>;
      case '/dashboard':
        return <span className="text-xs text-gray-500">Analytics overview</span>;
      case '/projects':
        return <span className="text-xs text-gray-500">Manage projects</span>;
      case '/assigned':
        return <span className="text-xs text-gray-500">Your tasks</span>;
      case '/':
        return <span className="text-xs text-gray-500">Campaign Home</span>;
      case '/qa':
        return <span className="text-xs text-gray-500">QA Scorecard</span>;
      case '/scorecards/view':
        return <span className="text-xs text-gray-500">View scorecards</span>;
      case '/quicksight':
        return <span className="text-xs text-gray-500">Dashboard</span>;
      case '/uploadRecs':
        return <span className="text-xs text-gray-500">Upload Recordings</span>;
      case '/fileCopy':
        return <span className="text-xs text-gray-500">Copy Files</span>;
      case '/override-logs':
        return <span className="text-xs text-gray-500">Audit</span>;
      case '/jobs':
        return <span className="text-xs text-gray-500">View upload jobs</span>;
      case '/CallAgent':
        return <span className="text-xs text-gray-500">My Calls</span>;
      case '/scheduled-jobs':
        return <span className="text-xs text-gray-500">Manage automated fetches</span>;
      default:
        return null;
    }
  };

  let navItems = [];

  if (isSAdmin) {
    navItems = [
      { path: "/search", label: "Search", icon: <FaSearch /> },
      { path: "/jobs", label: "Jobs", icon: <FaClipboardCheck /> },
      { path: "/scheduled-jobs", label: "Scheduled Jobs", icon: <FaDatabase /> },
      { path: "/templates", label: "Scorecards", icon: <FaFileAlt /> },
      { path: "/campaigns", label: "Campaigns", icon: <FaFolderOpen /> },
      { path: "/uploadRecs", label: "Upload Recordings", icon: <FaUpload /> },
      { path: "/override-logs", label: "Audit", icon: <FaBook /> },
      { path: "/users", label: "User Management", icon: <FaUser /> },
      { divider: true },
      { path: "/", label: "Campaign Home", icon: <FaHome /> },
      { path: "/quicksight", label: "Dashboard", icon: <FaChartBar /> },
      { path: "/fileCopy", label: "Cloud Connector", icon: <FaCloud /> },
      { divider: true },
      // { path: "/", label: "All calls", icon: <FaPhone /> }
      // Admins should not see the "Assigned to me" section
    ];
  } else if (isAdmin) {
    navItems = [
      { path: "/search", label: "Search", icon: <FaSearch /> },
      { path: "/jobs", label: "Jobs", icon: <FaClipboardCheck /> },
      { path: "/scheduled-jobs", label: "Scheduled Jobs", icon: <FaDatabase /> },
      { path: "/templates", label: "Scorecards", icon: <FaFileAlt /> },
      { path: "/campaigns", label: "Campaigns", icon: <FaFolderOpen /> },
      { path: "/uploadRecs", label: "Upload Recordings", icon: <FaUpload /> },
      { path: "/override-logs", label: "Audit", icon: <FaBook /> },
      { divider: true },
      { path: "/", label: "Campaign Home", icon: <FaHome /> },
      { path: "/quicksight", label: "Dashboard", icon: <FaChartBar /> },
      { path: "/fileCopy", label: "Cloud Connector", icon: <FaCloud /> },
      { divider: true },
      // { path: "/", label: "All calls", icon: <FaPhone /> }
      // Admins should not see the "Assigned to me" section
    ];
  } else if (isQAAgent) {
    navItems = [
      { path: "/assigned", label: "Assigned to me", icon: <FaUser /> },
      // { path: "/jobs", label: "Jobs", icon: <FaClipboardCheck /> },
      { path: "/uploadRecs", label: "Upload Recordings", icon: <FaUpload /> }
    ];
  } else if (isCallAgent) {
    navItems = [
      { path: "/CallAgent", label: "My Calls", icon: <FaPhone /> },
    ];
  }

  const handleNavigation = (path) => {
    setActiveHref(path);
    history.push(path);
    if (window.innerWidth < 768) {
      closeSidebar();
    }
  };

  return (
    <>
      <aside
        className={`fixed z-40 inset-y-0 left-0 transform bg-white shadow-lg flex flex-col h-full custom-scrollbar overflow-y-auto transition-transform duration-200 relative ${sidebarOpen ? 'translate-x-0 md:relative' : '-translate-x-full md:-translate-x-full md:absolute'}`}
        style={{ width: sidebarWidth }}
      >
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-lg font-medium text-gray-800">
            Smart Contact Center Quality Assurance Tool
          </h2>
        </div>
      
      <nav className="flex-1 p-4">
        <ul className="space-y-2">
          {navItems.map((item, index) => {
            if (item.divider) {
              return <li key={`divider-${index}`}><hr className="my-3 border-gray-200" /></li>;
            }

            return (
              <li key={item.path}>
                <button
                  onClick={() => handleNavigation(item.path)}
                  onMouseEnter={() => setHoveredItem(item.path)}
                  onMouseLeave={() => setHoveredItem(null)}
                  className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 group text-left ${
                    isActive(item.path)
                      ? 'bg-rewardsco-50 border-l-4 border-rewardsco-500 text-rewardsco-700'
                      : 'hover:bg-gray-50 text-gray-700'
                  }`}
                >
                  {React.cloneElement(item.icon, { className: 'text-xl' })}
                  <div className="flex-1">
                    <div className="font-medium">{item.label}</div>
                    {hoveredItem === item.path && getItemInfo(item.path)}
                  </div>
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
      <div className="p-4 border-t border-gray-200 mt-auto">
        <button
          onClick={() => {
            logOut();
            window.location.reload();
          }}
          className="btn-primary w-full justify-center"
        >
          {/* <FaSignOutAlt className="h-5 w-5" /> */}
          <span>Logout</span>
        </button>
      </div>
      <div
        className="absolute top-0 right-0 w-1 h-full cursor-col-resize bg-gray-200 hover:bg-gray-300"
        onMouseDown={() => setIsResizing(true)}
      />
    </aside>
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-30 md:hidden"
          onClick={closeSidebar}
        />
      )}
    </>
  );
}

function Breadcrumbs({ items }) {
  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-6">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <span className="text-gray-400">/</span>}
          {item.href && item.href !== "#" ? (
            <button 
              onClick={() => window.history.back()}
              className="hover:text-rewardsco-600 transition-colors focus-ring rounded px-1"
            >
              {item.text}
            </button>
          ) : (
            <span className={index === items.length - 1 ? "text-gray-800 font-medium" : ""}>{item.text}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}

function App() {
  const [alert, setAlert] = useState();
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 768);
  const isAdmin = useIsAdmin()
  const isQAAgent = useIsQAAgent()
  const isSAdmin = useIsSuperAdmin()
  const isCallAgent = useIsCallAgent()

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setSidebarOpen(true);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onDismiss = () => {
    setAlert(null);
  };
  const [hasRedirected, setHas] = useState(false);
  useEffect(() => {
    const trigLanding = () => {
    const pathname = window.location.pathname

    if (!hasRedirected && isQAAgent && !isAdmin && !isSAdmin && pathname === '/') {
      setHas(true);
      window.location.href = '/Assigned';
    } else if (!hasRedirected && isCallAgent && !isAdmin && !isSAdmin && !isQAAgent && pathname === '/') {
      setHas(true);
      window.location.href = '/CallAgent';
    }

    console.log("Redirected: ", hasRedirected)
 
    }
    trigLanding()
  }, [])

  const userToken = localStorage.getItem("id_token");
  const parsedToken = payloadFromToken(userToken);
  const cognitoUserName = parsedToken["cognito:username"] || "Unknown";
  const userGroups = parsedToken["cognito:groups"]
  console.log("group: ", userGroups)
  const cognitoEmail = parsedToken["email"] || "Unknown";



  return (
    <Router>
      <div className="min-h-screen bg-white text-gray-800">
        <TopNavigation
          userName={cognitoUserName}
          email={cognitoEmail}
          toggleSidebar={() => setSidebarOpen((v) => !v)}
        />
        
        <div className="flex h-[calc(100vh-73px)]">
          <SideNavigation
            sidebarOpen={sidebarOpen}
            closeSidebar={() => setSidebarOpen(false)}
          />
          
          <main className="flex-1 overflow-y-auto custom-scrollbar">
            {alert && (
              <div className="mx-6 mt-6">
                <div className={`p-4 rounded-lg border ${
                  alert.variant === 'error' ? 'bg-red-50 border-red-200 text-red-800' :
                  alert.variant === 'warning' ? 'bg-yellow-50 border-yellow-200 text-yellow-800' :
                  'bg-blue-50 border-blue-200 text-blue-800'
                }`}>
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="font-medium">{alert.heading}</h3>
                      <p className="mt-1 text-sm">{alert.text}</p>
                    </div>
                    <button
                      onClick={onDismiss}
                      className="ml-4 text-gray-400 hover:text-gray-600"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            )}
            
            <div className="page-container py-6">
              <Switch>
                {routes.map(({ path, Component, breadcrumbs, exact, sAdm, adm, qa, callAgent}) => {
                  // console.log("is SA :", sAdm, isSAdmin)
                  const hasAccess = (qa && isQAAgent) || (sAdm && isSAdmin) || (adm && isAdmin) || (callAgent && isCallAgent);
                  const dynamicBreadcrumbs = () => {
                  if (qa && isQAAgent) {
                      return [
                        { text: "Assigned", href: "/assigned" },
                        { text: "Call Details", href: "#" },
                      ];
                    } else if (callAgent && isCallAgent) {
                      return [
                        { text: "My Calls", href: "/CallAgent" },
                        { text: "Call Details", href: "#" },
                      ];
                    }
                    return breadcrumbs; // default for adm/sAdm
                  };
                  return (
                  <Route
                    key={path}
                    path={path}
                    exact={exact}
                    component={(props) => hasAccess ? (
                      <div className="fade-in">
                        <Breadcrumbs items={dynamicBreadcrumbs()} />
                        <Component
                          {...props}
                          setAlert={setAlert}
                          username={cognitoUserName}
                          userEmail={cognitoEmail}
                        />
                      </div>
                    ) : null}
                  />
                  );
                })}
              </Switch>
            </div>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;